import { Routes } from '@angular/router';

export const validacaoDeclaracaoRoutes: Routes = [
  {
    path: 'validacao-declaracao',
    data: {
      title: 'Validar Declaração de Atuação',
      breadcrumb: [
        { label: 'Validar Declaração de Atuação', url: '/validacao-declaracao' },
      ],
    },
    loadComponent: () =>
      import('./validacao-declaracao.component').then(
        (m) => m.ValidacaoDeclaracaoComponent,
      ),
  },
];
